// app routes
const routes = {
  companies: {
    pullHistory: "/companies/:companyId/pull-history",
    pushHistory: "/companies/:companyId/push-history",
  },
};

export default routes;
